import * as models from "../models";

declare global
{
    export interface JQuery
    {
        setCaretToPosition(start: number, end: number): void;
        setCaretToLastPosition(): void;
        scrollToTarget(target: JQuery.Selector, scrollUp?: boolean, scrollInSteps?: boolean): void;
        getOffset(includeMargin?: boolean, ignoreScrollbars?: boolean): models.ICoordinates;
        getPosition(parent?: JQuery.Selector | JQuery<HTMLElement> | JQuery.PlainObject<any>): models.ICoordinates;
        isOverflowing(parent?: JQuery.Selector): boolean;

        /**
         * Prüft ob das übergebene Element komplett sichtbar ist.
         * @param {JQuery.Selector} [parent] Wenn angegeben, wird geprüft ob das Element in diesem Element komplett sichtbar ist.
         * @return {Models.IViewport}
         */
        isFullyVisible(parent?: JQuery.Selector): models.IViewport;
    }
}

$.fn.setCaretToPosition = function(start: number, end: number): void
{
    var elem = this.get(0) as any;
    var elemLen = elem.value.length;
    if (elem.selectionStart || elem.selectionStart == '0')
    {
        elem.selectionStart = start;
        elem.selectionEnd = end;
        elem.focus();
    }
}

$.fn.setCaretToLastPosition = function(): void
{
    var elem = this.get(0) as any;
    var elemLen = elem.value.length;
    if (elem.selectionStart || elem.selectionStart == '0')
    {
        elem.selectionStart = elemLen;
        elem.selectionEnd = elemLen;
        elem.focus();
    }
}

$.fn.scrollToTarget = function(target: JQuery.Selector, scrollUp: boolean = false, scrollInSteps: boolean = true): void
{
    var $container: JQuery = this;
    var $target = $(target);
    var targetPos = $target.getPosition();

    if (scrollUp)
    {
        $container[0].scrollTop -= $target.outerHeight();
    }
    else if (targetPos.top < 0)
    {
        $container[0].scrollTop = targetPos.top;
    }
    else
    {
        if (scrollInSteps)
        {
            $container[0].scrollTop += $target.outerHeight();
        }
        else
        {
            $container[0].scrollTop = targetPos.top;
        }
    }
}

$.fn.getOffset = function(includeMargin: boolean = false, ignoreScrollbars: boolean = false): models.ICoordinates
{
    var element: JQuery = this;
    var offset: models.ICoordinates = element.offset() as any;

    if (ignoreScrollbars)
    {
        offset.right = window.innerWidth - offset.left - element.outerWidth(includeMargin);
        offset.bottom = window.innerHeight - offset.top - element.outerHeight(includeMargin);
    }
    else
    {
        offset.right = $(window).width() - offset.left - element.outerWidth(includeMargin);
        offset.bottom = $(window).height() - offset.top - element.outerHeight(includeMargin);
    }

    return offset;
}

$.fn.getPosition = function(parent?: JQuery.Selector | JQuery<HTMLElement> | JQuery.PlainObject<any>): models.ICoordinates
{
    var element: JQuery = this;
    var parentElem: JQuery = $(parent);
    var position: models.ICoordinates = element.position() as any;

    if (parent && parent.length > 0)
    {
        let offset: models.ICoordinates = element.getOffset();
        let parentOffset: models.ICoordinates = parentElem.getOffset();

        position.left = offset.left - parentOffset.left;
        position.top = offset.top - parentOffset.top;
        position.right = offset.right - parentOffset.right;
        position.bottom = offset.bottom - parentOffset.bottom;
    }
    else
    {
        let offset: models.ICoordinates = element.getOffset();
        let parentOffset: models.ICoordinates = element.parent().getOffset();

        position.right = offset.right - parentOffset.right;
        position.bottom = offset.bottom - parentOffset.bottom;
    }

    return position;
}

$.fn.isOverflowing = function(parent?: JQuery.Selector): boolean
{
    var $elem: JQuery = this;
    var $parent: JQuery = $(parent);

    if ($elem && $elem.length > 0)
    {
        var elemHeight = $elem.height();
        var elemTop = $elem.position().top;
        var parentHeight = (($parent.length > 0) ? $parent.height() : $elem.parent().height());

        return (parentHeight - (elemHeight + elemTop) < 0) || elemTop < 0;
    }
    else
    {
        return false;
    }
}

$.fn.isFullyVisible = function(parent?: JQuery.Selector): models.IViewport
{
    var element: JQuery = this;
    var parentElem: JQuery = $(parent);
    var position: models.ICoordinates;

    if (parent && parent.length > 0)
    {
        position = element.getPosition(parentElem);
    }
    else
    {
        position = element.getOffset();
    }

    return {
        top: position.top >= 0,
        left: position.left >= 0,
        bottom: position.bottom >= 0,
        right: position.right >= 0,
        isVisible: (
            position.top >= 0 &&
            position.left >= 0 &&
            position.bottom >= 0 &&
            position.right >= 0
        )
    };
}